import { render, staticRenderFns } from "./FundLaserPage.vue?vue&type=template&id=dec678dc&"
import script from "./FundLaserPage.vue?vue&type=script&lang=js&"
export * from "./FundLaserPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports